import { ABI, SamplePack } from '@arpeggi/shared'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { useIsSPEditionHolder } from '../../token-gating/hooks'
import { useUGCContractMetadata } from '../../web3-utils'
import { useMintCollectionState } from './useMintCollectionState'

const getMetadataParams = (sp: SamplePack) => ({
  contractAddress: sp?.edition?.contractAddress,
  abi: ABI.legacy.ERC721Generic_11_21_22,
  chain: sp?.edition?.chain,
  externalUrl: sp?.edition?.externalUrl,
  maxPurchasablePerWallet: sp?.edition?.maxPurchasablePerWallet || sp?.edition?.preSaleVolume || 1,
  preSalePrice: sp?.edition?.preSalePrice,
  editionId: sp?.edition?.id
})

export const useMintCollectionButton = (sp: SamplePack, isPresale?: boolean) => {
  const { currentWalletAddress } = useAuth()
  const { isHolder } = useIsSPEditionHolder(sp)
  const params = getMetadataParams(sp)
  const { mint, isMinting, totalMinted } = useUGCContractMetadata(params)
  const state = useMintCollectionState({ sp, isPresale, totalMinted })

  const allowedToMint = !isPresale

  let buttonText: string
  if (isHolder) buttonText = 'Already a Token Holder'
  else if (state.mintSoldOut) buttonText = 'Sold Out'
  else if (state.mintHasExpired) buttonText = 'Mint Expired'
  else if (!state.mintIsLive) buttonText = 'Sale Begins Soon'
  else if (!allowedToMint) buttonText = 'Not on Allowlist'
  else buttonText = 'Collect Pack Token'

  return {
    isHolder,
    allowedToMint,
    mint,
    isMinting,
    buttonText,
    ...state
  }
}
